<template>
	<v-flex
		xs12
		sm8
		md4
	>
		<v-card class="elevation-12">
			<v-toolbar
				dark
				flat
				color="primary"
			>
				<v-toolbar-title>Create Account</v-toolbar-title>
				<v-spacer/>
				<v-avatar
					size="32px"
					tile
				>
					<img
						src="/logo.png"
						alt="Report Mule logo."
					>
				</v-avatar>
			</v-toolbar>
			<v-progress-linear
				v-if="registration.saving"
				:indeterminate="true"
				class="ma-0"
			/>
			<div class="pa-2 grey lighten-2 text-xs-center"
				v-if="!token"
			>
				<div class="body-2">
					2 Week Free Trial. No Credit Card Required.
				</div>
			</div>
			<v-form
				ref="create"
				v-model="valid"
				@submit.prevent="submit"
			>
				<v-card-text>
					<v-text-field
						style="display: none;"
						v-model="registration.turnstileToken"
						:rules="validate.require"
					/>
					<v-text-field
						v-model="registration.realName"
						:rules="validate.requireCustomMessage('Full name field is required')"
						:disabled="registration.saving"
						prepend-icon="person"
						name="fullName"
						label="Full Name"
						type="text"
					/>
					<v-text-field
						v-model="registration.email"
						:rules="[...validate.requireCustomMessage('Email field is required'), validate.email]"
						:disabled="registration.saving"
						prepend-icon="email"
						name="email"
						label="Email"
						type="text"
					/>
					<v-text-field
						v-if="!token"
						v-model="registration.accountName"
						:rules="validate.requireCustomMessage('Account name field is required')"
						:disabled="registration.saving"
						prepend-icon="domain"
						name="accountName"
						label="Account Name"
						type="text"
					/>
					<v-text-field
						v-model="registration.password"
						:rules="[...validate.requireCustomMessage('Password field is required'), validate.lengthMin8]"
						:disabled="registration.saving"
						autocomplete="new-password"
						prepend-icon="lock"
						name="password"
						label="Password"
						type="password"
					/>
					<v-text-field
						v-model="registration.passwordConfirm"
						:rules="[validateSamePass(registration.passwordConfirm, registration.password)]"
						:disabled="registration.saving"
						prepend-icon="lock"
						name="password-confirm"
						label="Confirm Password"
						type="password"
					/>
					<v-checkbox
						v-model="acceptTerms"
						:rules="[v => v || 'You must accept the Terms and Conditions']"
						:disabled="registration.saving"
						color="primary"
					>
						<label slot="label">
							I have read the
							<a
								href="https://reportmule.com/terms"
								target="_blank"
							>
								Terms and Conditions
							</a>
						</label>
					</v-checkbox>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn
						:disabled="!valid || registration.saving"
						color="primary"
						type="submit"
						class="ma-2"
					>
						Create
					</v-btn>
				</v-card-actions>
			</v-form>
			<div class="cf-turnstile-wrapper">
				<div>
					<div id="cf-turnstile" />
				</div>
			</div>
		</v-card>
		<v-card class="elevation-12 mt-4">
			<v-toolbar>
				<v-toolbar-title>Existing User?</v-toolbar-title>
				<v-spacer/>
				<v-btn
					:to="{ name: 'Login' }"
					:disabled="registration.saving"
					flat
				>
					Log in
				</v-btn>
			</v-toolbar>
		</v-card>
	</v-flex>
</template>

<script>
import { Register } from '@/models/Register';
import Validation from '@/mixins/Validation';

export default {
	mixins: [Validation],
	data() {
		return {
			valid: true,
			registration: new Register(),
			acceptTerms: false,
			turnstileWidgetId: null,
		};
	},
	beforeMount() {
		if (window.turnstile === undefined || !window.turnstile) {
			this.$loadScript('https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback');
		}
	},
	mounted() {
		if (window.turnstile === undefined || !window.turnstile) {
			window.onloadTurnstileCallback = () => {
				this.renderTurnstile();
			};
		} else {
			this.renderTurnstile();
		}
	},
	beforeDestroy() {
		this.removeTurnstile();
	},
	computed: {
		token() {
			return this.$route.query.token || null;
		},
	},
	methods: {
		submit() {
			this.registration.token = this.token;
			this.registration.save().then((resp) => {
				this.$notify('success', 'Account created, redirecting now.');
				this.login(resp.response);
			}).catch((error) => {
				const message = error.response.response.data.message || 'Registration failed, please try again.';
				this.$notify('error', message);
			});
		},
		login(resp) {
			localStorage.authKey = resp.data.authKey;
			// Add auth params to localStorage
			this.$ls.login(resp);
			this.$router.replace('/projects');
		},
		renderTurnstile() {
			this.removeTurnstile();
			this.turnstileWidgetId = window.turnstile.render("#cf-turnstile", {
				sitekey: process.env.VUE_APP_CLOUDFLARE_TURNSTILE_SITE_KEY,
				callback: (token) => {
					this.registration.turnstileToken = token;
				},
			});
		},
		removeTurnstile() {
			if (this.turnstileWidgetId) {
				window.turnstile.remove(this.turnstileWidgetId);
				this.turnstileWidgetId = null;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.cf-turnstile-wrapper {
	display: flex;
	justify-content: center;
	padding: 8px;
	> div {
		height: 65px;
		width: 300px;
	}
}
</style>
